module.exports = __webpack_public_path__ + "static/media/Draw.0a9c3e3d.png";